<template>
  <FeatureDetailPage feature-key="memberships" />
</template>
